import { supabase } from '../supabaseClient';

/**
 * 記錄抽籤結果
 * @param {Object} drawData - 抽籤資料
 * @param {string} drawData.userId - 用戶 ID
 * @param {string} drawData.userName - 用戶名稱
 * @param {string} drawData.userEmail - 用戶 Email
 * @param {string} drawData.prizeName - 獎項名稱
 * @param {string} drawData.prizeMessage - 獎項訊息
 * @param {string} drawData.prizeTier - 獎項稀有度
 * @param {string} drawData.companyId - 公司 ID
 * @param {string} drawData.departmentId - 部門 ID
 * @returns {Promise<{data, error}>}
 */
export const recordLuckyDraw = async (drawData) => {
  try {
    const { data, error } = await supabase
      .from('lucky_draw_history')
      .insert({
        user_id: drawData.userId,
        user_name: drawData.userName,
        user_email: drawData.userEmail,
        prize_name: drawData.prizeName,
        prize_message: drawData.prizeMessage,
        prize_tier: drawData.prizeTier,
        company_id: drawData.companyId,
        department_id: drawData.departmentId,
        draw_year: new Date().getFullYear()
      })
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('記錄抽籤失敗:', error);
    return { data: null, error };
  }
};

/**
 * 取得用戶的抽籤歷史
 * @param {string} userId - 用戶 ID（選填，不填則查詢當前用戶）
 * @param {number} year - 年份（選填，不填則查詢所有年份）
 * @returns {Promise<{data, error}>}
 */
export const getLuckyDrawHistory = async (userId = null, year = null) => {
  try {
    let query = supabase
      .from('lucky_draw_history')
      .select('*')
      .order('drawn_at', { ascending: false });

    if (userId) {
      query = query.eq('user_id', userId);
    }

    if (year) {
      query = query.eq('draw_year', year);
    }

    const { data, error } = await query;

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('取得抽籤歷史失敗:', error);
    return { data: null, error };
  }
};

/**
 * 取得部門的抽籤歷史
 * @param {string} departmentId - 部門 ID
 * @param {number} year - 年份（選填）
 * @returns {Promise<{data, error}>}
 */
export const getDepartmentLuckyDrawHistory = async (departmentId, year = null) => {
  try {
    let query = supabase
      .from('lucky_draw_history')
      .select('*')
      .eq('department_id', departmentId)
      .order('drawn_at', { ascending: false });

    if (year) {
      query = query.eq('draw_year', year);
    }

    const { data, error } = await query;

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('取得部門抽籤歷史失敗:', error);
    return { data: null, error };
  }
};
